import Box from '@mui/material/Box';
import { Skeleton } from '../../components/Skeleton';

export interface SidebarMenuSkeletonProps {
  collapsed: boolean;
}

// Larguras variadas para o placeholder não parecer um bloco uniforme.
const ITEM_WIDTHS = ['70%', '55%', '80%', '60%', '75%', '50%', '68%', '58%'];

/**
 * Placeholder exibido enquanto uma troca/saída de conta está pendente do refresh
 * de token. Evita mostrar o menu com permissões em transição; some assim que a
 * `useSidebar` recebe o token definitivo e volta a montar os itens reais.
 */
export function SidebarMenuSkeleton({ collapsed }: SidebarMenuSkeletonProps): JSX.Element {
  return (
    <Box sx={{ p: 1 }} aria-busy="true" aria-live="polite">
      {ITEM_WIDTHS.map((width) => (
        <Box key={width} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 1.25 }}>
          <Skeleton
            variant="circular"
            width={20}
            height={20}
            sx={{ flexShrink: 0, bgcolor: 'sidebar.skeleton' }}
          />
          {!collapsed && (
            <Skeleton variant="text" width={width} sx={{ bgcolor: 'sidebar.skeleton' }} />
          )}
        </Box>
      ))}
    </Box>
  );
}
